import { api } from "./api";

export async function uploadAttachment(file, purpose, subjectId, onProgress, pending) {
  const signature=`${purpose}:${subjectId}:${file.name}:${file.size}:${file.lastModified}`;
  if(pending.current?.signature!==signature) pending.current={signature,upload:null,next:0,ready:null};
  const state=pending.current;
  if(state.ready)return state.ready;
  if(!state.upload){onProgress('Preparing upload…');state.upload=(await api.post('/attachments',{purpose,subject_id:subjectId,filename:file.name,size:file.size})).data;}
  const {asset_id,chunk_size}=state.upload, total=Math.ceil(file.size/chunk_size);
  for(let i=state.next;i<total;i++){
    onProgress(`Uploading ${Math.round(i/total*100)}% · chunk ${i+1}/${total}`);
    await api.put(`/attachments/${asset_id}/chunks/${i}`,file.slice(i*chunk_size,(i+1)*chunk_size),{headers:{'Content-Type':'application/octet-stream'},timeout:120000});
    state.next=i+1;
  }
  onProgress('Verifying stored file…');
  state.ready=(await api.post(`/attachments/${asset_id}/complete`,{},{timeout:120000})).data;
  onProgress('Upload verified');
  return state.ready;
}

export async function downloadAttachment(asset) {
  const {data}=await api.get(`/attachments/${asset.asset_id}/download`,{responseType:'blob',timeout:120000});
  const url=URL.createObjectURL(data), a=document.createElement('a');a.href=url;a.download=asset.filename;a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
